import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import uniqueId from 'lodash/uniqueId';
import { OverlayTrigger, Tooltip } from '@cancercentrum/rcc-bootstrap';
export const HintText = (props)=>{
    const { tooltip, text, trigger, placement = 'top' } = props;
    const id = useMemo(()=>props.id || uniqueId('HintText_'), [
        props.id
    ]);
    const tooltipOverlay = /*#__PURE__*/ _jsx(Tooltip, {
        id: id,
        className: "hint-text__tooltip",
        children: tooltip
    });
    return(// @ts-ignore typ ej exporterad från rcc-bootstrap.
    /*#__PURE__*/ _jsx(OverlayTrigger, {
        placement: placement,
        overlay: tooltipOverlay,
        trigger: trigger,
        children: /*#__PURE__*/ _jsx("div", {
            className: "hint-text d-inline",
            children: text
        })
    }));
};
